import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {TaskService} from '../../../../services/task.service';

@Component({
  selector: 'app-pulse-created-send-notification',
  templateUrl: './pulse-created-send-notification.component.html',
  styleUrls: ['../parts.css']
})
export class PulseCreatedSendNotificationComponent implements OnInit {

  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  // 分组
  groupConditionVisible: boolean; // 分组POP是否关闭
  groupConditionId = null; // 分组选中ID
  groupConditionDisplayText = '分组'; // 条件二默认文字

  keywordPopVisible = false;
  mailPopVisible = false;
  receiverPopVisible = false;

  smsPattern = 'custom';
  smsTemplateList;
  notificationData: any; // 存放通知组件数据

  // 其他
  isConfirmLoading = false; // 确定按钮
  recipeId = null; // 自动化模板ID
  relationId;
  instanceData: any = {}; // 存放实例返填数据
  taskIntegrationData: any = {}; // 存放任务数据
  categorieId: string; // 存放当前目录ID
  automation = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    keyword: '',
    email: null,
    siteMessage: null,
    sms: null,
    receiver: {
    },
    conditions: [{}]
  }; // 存放入参数据
  @ViewChild('pulseCard', { static: true }) pulseCard: any;
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private taskService: TaskService
  ) { }

  ngOnInit(): void {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups : [];
      this.boardColumnData = this.boardData.boardData.columns ? this.boardData.boardData.columns : [];
      this.boardPulseData = this.boardData.boardData.pulses ? this.boardData.boardData.pulses : [];
    }
    // 带入菜单ID
    this.automation.categoryId = this.categorieId;
    this.automation.relationId = this.relationId;
    // 回填实例数据
    if (this.instanceData && this.instanceData.config) {
      this.groupConditionId = this.instanceData.config.groupId;
      for (let group of this.boardGroupData) {
        if (group.id == this.groupConditionId) {
          this.groupConditionDisplayText = group.title;
          break;
        }
      }
      this.automation = JSON.parse(JSON.stringify(this.instanceData.config));
      this.notificationData = this.instanceData.config.email || this.instanceData.config.siteMessage || this.instanceData.config.sms;
      this.packageData(this.automation);
    }
    if (this.automation.groupId) {
      this.groupConditionId = this.automation.groupId;
      const groupNames = [];
      for (const group of this.boardGroupData) {
        if (this.groupConditionId.includes(group.id)) {
          group.checked = true;
          groupNames.push(group.title);
        }
      }
      this.groupConditionDisplayText = groupNames.join(',');
      this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
        `${this.groupConditionDisplayText.slice(0, 12)}...` : this.groupConditionDisplayText;
    }
    if (this.smsPattern === 'template') {
      this.taskService.querySmsTemplateList().subscribe(res => {
        this.smsTemplateList = res;
        if (this.smsTemplateList && this.smsTemplateList.length > 0) {
          for (const template of this.smsTemplateList) {
            template['content'] = JSON.parse(template['content']);
          }
        }
      });
    }
  }

  // 分组变更
  groupConditionChange(item) {
    item.checked = !item.checked;
    this.getGroupIds();
    this.automation.groupId = this.groupConditionId;
    this.packageData(this.automation);
  }

  getGroupIds() {
    const idSet = new Set();
    const groupNames = [];
    for (const group of this.boardGroupData) {
      if (group.checked) {
        idSet.add(group.id);
        groupNames.push(group.title);
      }
    }
    const ids = Array.from(idSet);
    this.groupConditionId = ids.join(',');
    this.groupConditionDisplayText = groupNames.join(',');
    this.groupConditionDisplayText = this.groupConditionDisplayText.length > 12 ?
      `${this.groupConditionDisplayText.slice(0, 12)}...` : this.groupConditionDisplayText;
  }

  keywordChange() {
    this.packageData(this.automation);
  }

  getNotificationData(data) {
    this.notificationData = data.content;
    if (data.type === 'email') {
      this.automation.email = data.content;
      this.automation.siteMessage = null;
      this.automation.sms = null;
    } else if (data.type === 'siteMessage') {
      this.automation.siteMessage = data.content;
      this.automation.email = null;
      this.automation.sms = null;
    } else {
      this.automation.sms = data.content;
      this.automation.email = null;
      this.automation.siteMessage = null;
    }
    this.mailPopVisible = false;
  }

  getUserData(data) {
    this.automation.receiver = data;
    this.packageData(this.automation);
  }

  // 组件提交数据
  packageData(data) {
    data.instanceDescription = '当更新在 ' + this.groupConditionDisplayText + ' 中的行中被创建且包含 关键字 时， 发送 通知 给 用户';
    this.nfDataChange.emit(data);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus() : boolean {
    return this.groupConditionId &&
      (this.automation.email || this.automation.siteMessage || this.automation.sms) &&
      (this.automation.receiver && this.automation.receiver['value'] && this.automation.receiver['value'].length > 0);
  }
}
